import router from '@/router/index.js';
import store from '@/store/index.js';
import { UNAUTHORIZED_ROUTES_NAMES } from '@/settings.js';
import { SET_REQUESTED_PATH } from '@/store/mutationTypes.js';

export default router.beforeResolve((to, from, next) => {
  const isRequestedPathUnauthorizedRoute = UNAUTHORIZED_ROUTES_NAMES.some(
    (route) => route === to.name,
  );

  if (store.state.user.userId === null && !isRequestedPathUnauthorizedRoute) {
    store.commit(SET_REQUESTED_PATH, { path: to });
    next({ name: 'Login' });
  } else {
    next();
  }
});
